export const environment = {
  production: false,
  baseURL: '/api',
  imageURL: 'https://dev-bo.nutridayquocte.com/api/files',
  tempUser:
    'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJraGFuZzEiLCJpYXQiOjE3MDU4MDQ0NzcsImV4cCI6MTcwNjY2ODQ3N30.lzFICak5ChYUsht08EiPb1-U44QwGBjri4x46HTwgE75fDKNEDV4NNN6_CvzjkQnFdjJVlQbrM_LgIIdkrDICw',
  user: 'khang1',
  password: '12345678',
};
